module.exports = __webpack_public_path__ + "img/detalhe-tec.63118b9d.svg";